/** Router mínimo sobre el hash. Sin dependencia externa: doce rutas no justifican una. */
import { useEffect, useState } from 'react';
import { DEFAULT_ROUTE, routeForPath, type RouteDef } from './routes.ts';

const read = (): string => window.location.hash.replace(/^#/, '') || DEFAULT_ROUTE.path;

export function navigate(path: string): void {
  window.location.hash = path;
}

/** Devuelve la ruta activa, o `null` si la URL no corresponde a ninguna vista real. */
export function useRoute(): { route: RouteDef | null; path: string } {
  const [path, setPath] = useState<string>(read);
  useEffect(() => {
    const onHash = () => setPath(read());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  return { route: routeForPath(path), path };
}
